// 加盟商管理
export default [
  {
    path: "/franchisee",
    name: "franchisee",
    meta: { title: "加盟商管理" },
    component: () => import("../views/franchisee/index"),
    children: [
      {
        path: "/franchisee/list",
        name: "franchiseeList",
        meta: { title: "加盟商列表", isMenu: true },
        component: () => import("../views/franchisee/list"),
      },
      {
        path: "/franchisee/list/details",
        name: "franchiseeDdetails",
        meta: { title: "加盟商详情" },
        component: () => import("../views/franchisee/detail/details"),
      },
      {
        path: "/franchisee/accounts",
        name: "franchiseeAccounts",
        meta: { title: "加盟商分账设置", isMenu: true },
        component: () => import("../views/franchisee/accounts"),
      },
    ],
  },
]